<div class="container p-5">
    <div id="header" class="d-flex flex-col justify-content-between mx-auto">
        <h1 style="display:inline" class="mr-auto">Manage Users</h1>
        <!-- NEED TO COMPONENTIZE -->
        <div>
            <button
                type="button"
                class="btn btn-primary"
                (click)="handleAction({col: {label: tableActions.Add}})">
                Add New User <fa-icon [icon]="faPlus"></fa-icon>
            </button>
        </div>
    </div>
    <app-table (iconClick)="handleAction($any($event))"></app-table>
</div>